import React, { memo, useCallback, useEffect, useState } from 'react'
import ProductDetailsForm from './product-details/ProductDetailsForm'
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setupSolarProductDetails } from '../../../stores/slices/solar-product-details-slice';
import { toast } from 'react-toastify';
import CommonLoadingSpinnerForPage from '../../../common/components/loading-spinner/CommonLoadingSpinnerForPage';
import { useLazyGetByIdQuery } from '../../../service/solar-product-service';

type Props = {}

const EditProduct: React.FC<Props> = memo((props: Props) => {
    let { id = "" } = useParams();

    const dispatch = useDispatch();
    const [getById, { isLoading }] = useLazyGetByIdQuery();

    useEffect(() => {
        if (id) {
            const fetchProduct = async () => {
                try {
                    const response = await getById(id).unwrap();
                    
                    dispatch(setupSolarProductDetails(
                        {
                            editingProductId: id,
                            currentStep: 0,
                            firstStep: {
                                productName: response.productName,
                                productCapacity: response.productCapacity,
                                price: response.price.amount,
                                activeDuration: response.activeDuration?.toString(),
                                batteryType: response.batteryType,
                                packageDescription: response.packageDescription,
                                categoryIds: response.categories.map(item => item.id)
                            },
                            secondStep: {
                                inverterType: response.inverterType,
                                warranty: response.warranty,
                                batteryVoltage: response.batteryVoltage,
                                type: response.type,
                                quantityAvailableForSale: response.quantityAvailableForSale?.toString()
                            },
                            thirdStep: {
                                costForBungalow: response.installationCostForBungalow.toString(),
                                costPerFloor: response.installationCostForFloorForStoryBuilding.toString(),
                                existingImages: response.images.map((image) => {
                                    return {
                                        name: image.imageUrl.split('/').pop() as string,
                                        url: image.imageUrl,
                                    }
                                }),
                                images: response.images.map((image) => {
                                    return {
                                        name: image.imageUrl.split('/').pop() as string,
                                        url: image.imageUrl,
                                    }
                                })
                            }
                        }
                    ));
                } catch (error) {
                    toast.error("An error occurred while fetching product details");
                }
            };
            
            fetchProduct();
        }
    }, [id, dispatch, getById]);

    return (
        <CommonLoadingSpinnerForPage loading={isLoading}>
            <ProductDetailsForm/>
        </CommonLoadingSpinnerForPage>
    )
})

export default EditProduct